import { render, staticRenderFns } from "./StcdR_Result_TransSummary.vue?vue&type=template&id=90125ffa"
import script from "./StcdR_Result_TransSummary.vue?vue&type=script&lang=js"
export * from "./StcdR_Result_TransSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports